/**
 Copyright Highway9 Networks Inc.
 */
import { AlertProfile, OutputPluginTemplate} from "~/types/AlertProfile";
import APIService from "./APIServices";
import { AlertGroup } from "~/types/AlertGroup";

const alertProfileAPI = new APIService<AlertProfile>("alertProfile");

const alertTypeAPI = new APIService<AlertGroup>("alerts/template");
const alertOutputPluginAPI = new APIService<OutputPluginTemplate>("outputPlugins/template");

export const alertService = {
  getAlertProfiles: alertProfileAPI.getAll,
  addAlertProfile: alertProfileAPI.create,
  updateAlertProfile: alertProfileAPI.update,
  deleteAlertProfile: alertProfileAPI.delete,
  getAlertTemplates,
  getAlertOutputPluginTemplates
};

export type AlertTemplateQuery = {
  sourceType?: "radio" | "edge" | "device" | "clock"
}

async function getAlertTemplates(query?: AlertTemplateQuery) {
  const q = query || {}
  const response = await alertTypeAPI.post<AlertGroup[]>('query', q as any)
  return response as unknown as AlertGroup[]
}

async function getAlertOutputPluginTemplates() {
  const response = await alertOutputPluginAPI.getAll()
  return response 
}



